module.exports = __webpack_public_path__ + "img/login-light.8374dae7.svg";